import React, { useState } from 'react';
import { Calendar, MapPin, Clock, Users, MessageSquare, Award, ArrowRight } from 'lucide-react';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
export const WarriEvent2025 = () => {
  const [activeTab, setActiveTab] = useState('details');
  const eventQuotes = ['Network and Grow', "Don't only use bridges, build them.", "Opportunities don't just knock—they're introduced through people.", 'Give, and Give; it comes back to you in greater measure.'];
  return <div className="pt-20 bg-white" data-id="element-4822">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-300" data-id="element-4823">
        <div className="absolute inset-0 z-0" data-id="element-4824">
          <div className="w-full h-full bg-gray-200 border-2 border-dashed border-gray-400" data-id="element-4825"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-4826">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4827">
            <div className="inline-block bg-white border border-gray-300 px-4 py-1 rounded-md text-sm font-bold mb-6" data-id="element-4828">
              UPCOMING EVENT
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" data-id="element-4829">
              Networking Salon: Warri Edition 2025
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-4830">
              Connect with ambitious professionals in Warri and build meaningful
              relationships that unlock new opportunities.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-4831">
              <Button className="border-2 border-gray-800" data-id="element-4832">Register Now</Button>
              <Button variant="outline" className="border-2 border-gray-400" data-id="element-4833">
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Event Details Section */}
      <section className="py-12 border-b border-gray-300" data-id="element-4834">
        <div className="container mx-auto px-4" data-id="element-4835">
          <div className="max-w-4xl mx-auto" data-id="element-4836">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-4837">
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4838">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4839">
                  <Calendar size={24} className="text-gray-700" data-id="element-4840" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4841">Date</h3>
                <p className="text-gray-600" data-id="element-4842">August 30, 2025</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4843">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4844">
                  <MapPin size={24} className="text-gray-700" data-id="element-4845" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4846">Venue</h3>
                <p className="text-gray-600" data-id="element-4847">Deluxe á la Carte Restaurant</p>
                <p className="text-gray-600" data-id="element-4848">Warri, Nigeria</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4849">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4850">
                  <Clock size={24} className="text-gray-700" data-id="element-4851" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4852">Time</h3>
                <p className="text-gray-600" data-id="element-4853">4:00 PM - 7:00 PM</p>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg overflow-hidden mb-8" data-id="element-4854">
              <div className="flex border-b border-gray-300" data-id="element-4855">
                <button className={`px-6 py-3 font-medium ${activeTab === 'details' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('details')} data-id="element-4856">
                  Event Details
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'agenda' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('agenda')} data-id="element-4857">
                  Agenda
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'speakers' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('speakers')} data-id="element-4858">
                  Speakers
                </button>
              </div>
              <div className="p-6" data-id="element-4859">
                {activeTab === 'details' && <div data-id="element-4860">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4861">
                      About This Event
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-4862">
                      Join us for an evening of meaningful connections,
                      inspiring conversations, and opportunities in Warri. The
                      Networking Salon brings together ambitious professionals,
                      entrepreneurs, and changemakers to build relationships
                      that matter.
                    </p>
                    <p className="text-gray-600 mb-4" data-id="element-4863">
                      This special edition will focus on creating strategic
                      connections among Warri's growing professional community,
                      with structured networking activities, curated
                      discussions, and opportunities to share ideas.
                    </p>
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4864">
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-4865">
                        <Users size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-4866" />
                        <div data-id="element-4867">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-4868">
                            Who Should Attend
                          </h4>
                          <p className="text-gray-600" data-id="element-4869">
                            Professionals, entrepreneurs, creatives, and
                            change-makers ages 18-45
                          </p>
                        </div>
                      </div>
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-4870">
                        <Award size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-4871" />
                        <div data-id="element-4872">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-4873">
                            What You'll Gain
                          </h4>
                          <p className="text-gray-600" data-id="element-4874">
                            Strategic connections, visibility, and access to
                            opportunities
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'agenda' && <div data-id="element-4875">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4876">
                      Event Agenda
                    </h3>
                    <div className="space-y-6" data-id="element-4877">
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4878">
                        <div className="flex items-center mb-2" data-id="element-4879">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4880">
                            <span className="text-gray-700 font-bold" data-id="element-4881">1</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4882">
                            4:00 PM - 4:30 PM: Registration & Welcome
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4883">
                          Check-in, receive your name tag, and enjoy welcome
                          refreshments
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4884">
                        <div className="flex items-center mb-2" data-id="element-4885">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4886">
                            <span className="text-gray-700 font-bold" data-id="element-4887">2</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4888">
                            4:30 PM - 5:00 PM: Keynote Session
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4889">
                          Opening remarks and keynote presentation on building
                          powerful networks
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4890">
                        <div className="flex items-center mb-2" data-id="element-4891">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4892">
                            <span className="text-gray-700 font-bold" data-id="element-4893">3</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4894">
                            5:00 PM - 6:00 PM: Structured Networking
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4895">
                          Guided networking activities designed to create
                          meaningful connections
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4896">
                        <div className="flex items-center mb-2" data-id="element-4897">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4898">
                            <span className="text-gray-700 font-bold" data-id="element-4899">4</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4900">
                            6:00 PM - 6:45 PM: Panel Discussion
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4901">
                          Industry leaders share insights on opportunities in
                          Warri and beyond
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4902">
                        <div className="flex items-center mb-2" data-id="element-4903">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4904">
                            <span className="text-gray-700 font-bold" data-id="element-4905">5</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4906">
                            6:45 PM - 7:00 PM: Closing & Next Steps
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4907">
                          Wrap-up, next steps, and information about future
                          events
                        </p>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'speakers' && <div data-id="element-4908">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4909">
                      Featured Speakers
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4910">
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-4911">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-4912"></div>
                        <div data-id="element-4913">
                          <h4 className="font-bold text-gray-800" data-id="element-4914">
                            Andrew Igbineweka
                          </h4>
                          <p className="text-gray-600" data-id="element-4915">
                            Founder, The Networking Salon
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-4916">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-4917"></div>
                        <div data-id="element-4918">
                          <h4 className="font-bold text-gray-800" data-id="element-4919">
                            Local Lead
                          </h4>
                          <p className="text-gray-600" data-id="element-4920">Warri City Ambassador</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-4921">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-4922"></div>
                        <div data-id="element-4923">
                          <h4 className="font-bold text-gray-800" data-id="element-4924">
                            Guest Speaker
                          </h4>
                          <p className="text-gray-600" data-id="element-4925">Industry Expert</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-4926">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-4927"></div>
                        <div data-id="element-4928">
                          <h4 className="font-bold text-gray-800" data-id="element-4929">
                            Panel Moderator
                          </h4>
                          <p className="text-gray-600" data-id="element-4930">Community Leader</p>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Event Highlights */}
      <section className="py-12 border-b border-gray-300" data-id="element-4931">
        <div className="container mx-auto px-4" data-id="element-4932">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-4933">
            Event Highlights
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-4934">
            <div className="relative aspect-[4/3] border-2 border-dashed border-gray-400 rounded-lg overflow-hidden" data-id="element-4935">
              <div className="absolute inset-0 bg-gray-100 flex items-center justify-center" data-id="element-4936">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-4937">
                  <MessageSquare size={32} className="text-gray-500" data-id="element-4938" />
                </div>
              </div>
            </div>
            <div data-id="element-4939">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4940">
                Inspiring Conversations
              </h3>
              <div className="space-y-4" data-id="element-4941">
                {eventQuotes.map((quote, index) => <div key={index} className="border-l-2 border-gray-400 pl-4" data-id="element-4942">
                    <p className="text-gray-700 font-medium" data-id="element-4943">{quote}</p>
                  </div>)}
              </div>
              <div className="mt-6" data-id="element-4944">
                <p className="text-gray-600" data-id="element-4945">
                  Join us at Deluxe á la Carte Restaurant in Warri for an
                  evening of meaningful networking and inspiration. Connect with
                  like-minded professionals and discover new opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Registration Section */}
      <section className="py-12 border-b border-gray-300 bg-gray-50" data-id="element-4946">
        <div className="container mx-auto px-4" data-id="element-4947">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4948">
            <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-4949">
              Secure Your Spot
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-4950">
              Limited seats available. Register now to join The Networking Salon
              Warri Edition.
            </p>
            <div className="border-2 border-gray-300 rounded-lg p-6 bg-white mb-8" data-id="element-4951">
              <div className="flex justify-center mb-6" data-id="element-4952">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-4953">
                  <Award size={32} className="text-gray-700" data-id="element-4954" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-4955">
                Event Registration
              </h3>
              <div className="text-center mb-6" data-id="element-4956">
                <p className="text-3xl font-bold text-gray-800" data-id="element-4957">₦5,000</p>
                <p className="text-gray-600" data-id="element-4958">per person</p>
              </div>
              <ul className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-4959">
                <li className="flex items-start" data-id="element-4960">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-4961">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4962"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-4963">
                    Full access to the networking event
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4964">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-4965">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4966"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-4967">Refreshments and dinner</span>
                </li>
                <li className="flex items-start" data-id="element-4968">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-4969">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4970"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-4971">
                    Professional networking materials
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4972">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-4973">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4974"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-4975">
                    Access to post-event connections
                  </span>
                </li>
              </ul>
              <Button className="w-full border-2 border-gray-800" data-id="element-4976">
                Register Now
              </Button>
            </div>
            <p className="text-gray-600" data-id="element-4977">
              Inner Circle members receive a special discount.
              <Link to="/membership" className="underline ml-1" data-id="element-4978">
                Learn more about membership
              </Link>
            </p>
          </div>
        </div>
      </section>
      {/* Location Map */}
      <section className="py-12" data-id="element-4979">
        <div className="container mx-auto px-4" data-id="element-4980">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-4981">
            Event Location
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-4982">
            <div className="aspect-[16/9] border-2 border-gray-300 rounded-lg overflow-hidden mb-6" data-id="element-4983">
              <div className="w-full h-full bg-gray-200 flex items-center justify-center" data-id="element-4984">
                <div className="text-center" data-id="element-4985">
                  <MapPin size={48} className="text-gray-400 mx-auto mb-2" data-id="element-4986" />
                  <p className="text-gray-600" data-id="element-4987">
                    Map of Deluxe á la Carte Restaurant, Warri
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4988">
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-4989">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4990">
                  Venue Details
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-4991">
                  <strong data-id="element-4992">Deluxe á la Carte Restaurant</strong>
                  <br data-id="element-4993" />
                  Warri, Delta State, Nigeria
                </p>
                <p className="text-gray-600" data-id="element-4994">
                  A premium dining venue with excellent facilities for
                  networking events. The restaurant offers a comfortable
                  atmosphere conducive to meaningful conversations and
                  connections.
                </p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-4995">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4996">
                  Contact Information
                </h3>
                <div className="space-y-4" data-id="element-4997">
                  <p className="text-gray-600" data-id="element-4998">
                    <strong data-id="element-4999">Event Coordinator:</strong>
                    <br data-id="element-5000" />
                    The Networking Salon Team
                    <br data-id="element-5001" />
                    info@thenetworkingsalon.live
                  </p>
                  <p className="text-gray-600" data-id="element-5002">
                    <strong data-id="element-5003">Local Lead:</strong>
                    <br data-id="element-5004" />
                    Warri City Ambassador
                    <br data-id="element-5005" />
                    warri@thenetworkingsalon.live
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-16 bg-gray-50" data-id="element-5006">
        <div className="container mx-auto px-4 text-center" data-id="element-5007">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 max-w-2xl mx-auto" data-id="element-5008">
            Join Us in Warri to Build Connections That Matter
          </h2>
          <Button className="border-2 border-gray-800" data-id="element-5009">
            Register for the Event
            <ArrowRight size={16} className="ml-2" data-id="element-5010" />
          </Button>
        </div>
      </section>
    </div>;
};